<template>
  <div @click="selectSession" :style="boxHeight" class="past-session">
    <div class="info">
      <span class="time">{{ slotTimeString }}</span>
      <a v-if="partnerID" :href="`/profile/${partnerID}`" class="title">
        {{ partnerName }}
      </a>
      <span v-else class="title"> {{ partnerName }} </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PastSession",
  props: ["boxHeight", "slotTimeString", "partnerData"],
  computed: {
    partnerID: function () {
      return this.partnerData ? this.partnerData.partnerID : null;
    },
    partnerName: function () {
      return this.partnerData ? this.partnerData.partnerName : "unmatched";
    },
  },
  methods: {
    selectSession() {
      console.log("Old session has been selected!");
    },
  },
};
</script>
<style scoped>
.past-session {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;

  z-index: 993;
}

.past-session .info {
  background-color: #ffffff;
  height: 92%;
  width: 95%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  pointer-events: auto;
  /* box-shadow: 0px 1px 3px 0px #f2f5f5; */
  border-radius: 2px;
  color: #323333;
  font-size: 16px;
  /* border: 1px solid #f7f7f9; */
  /* box-shadow: 0px 1px 2px 0px #d0d0d0; */
  border: 1px solid #efefef;
  background-color: #fafafb;
}

.past-session .time {
  padding: 2px 6px;
  padding-top: 3px;
  /* padding-right: 22px; */
  border-radius: 360px;
  /* border-top-left-radius: 10px; */
  /* border-bottom-right-radius: 32px; */
  font-size: 13px !important;
  font-weight: bold;
  color: #323333a6;
  margin-right: auto;
  /* margin-top: -5px; */
  font-weight: 800;
  /* margin-left: 8px; */
  position: absolute;
  top: 5px;
  left: 6px;
  /* background-color: #f6f2ff; */
  /* background-color: #ebecfb; */
  background-color: #f7f7f7;
  background-color: white;
  border: 1px solid #eaeaea;
}

.past-session .title,
.past-session .title-unmatched {
  position: absolute;
  top: 29px;
  left: 10px;
  font-size: 17px;
  font-weight: 700;
  text-transform: capitalize;
  width: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  border: 1px solid transparent;
  left: 3px;
  border-radius: 360px;
  padding: 0px 7px;
  cursor: pointer;
  height: 32px;
  box-sizing: border-box;
  width: 138px;
  display: flex;
  align-items: center;
}

.past-session .title-unmatched {
  color: #323333a6;
  text-transform: none;
  text-align: left;
}

.past-session .title {
  white-space: nowrap;
  color: #323333a6;
}

.past-session .title:hover {
  border: 1px solid #eaeaea;
}
</style>